import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core'
import { SlickCarouselComponent } from 'ngx-slick-carousel'

import { ITrack } from '../../../Interface/track'
import { SsrService } from '../../../services/ssr.service'
import { ProducerItemType } from '../../../types/producer.type'

@Component({
  selector: 'bmcore-common-slider',
  templateUrl: './bmcore-common-slider.component.html',
  styleUrls: ['../bmcore-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCommonSliderComponent implements OnInit {
  @Input() tracks: ITrack[] = []
  @Input() producers: ProducerItemType[] = []

  @ViewChild('slickModal') slickModal: SlickCarouselComponent

  slideConfig = {
    slidesToShow: 6,
    slidesToScroll: 6,
    nextArrow: "<div class='nav-btn next-slide'>&#10093;</div>",
    prevArrow: "<div class='nav-btn prev-slide'>&#10092;</div>",
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          dots: true
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  }

  constructor(private ssrService: SsrService) {}

  ngOnInit(): void {
    this.ssrService.isRehydratedSubject.subscribe(isRehydrated => {
      if (isRehydrated) {
        this.slickModal?.unslick()
        this.slickModal?.initSlick()
      }
    })
  }
}
